module.exports = __webpack_public_path__ + "static/media/Cadastro.29f462ef.svg";